import Lomake from "@/components/02-organisms/Lomake";
import { useChangeObjectsByAnchorWithoutUnderRemoval } from "@/stores/muutokset";
import localForage from "localforage";
import { PaikallisenTietovarastonAvain } from "@/enums";
import { useEffect, useState } from "react";

const Kokeilulupa = () => {
  const [changeObjects] = useChangeObjectsByAnchorWithoutUnderRemoval({
    anchor: "kokeilulupa"
  });

  const [isKokeilulupaChecked, setIsKokeilulupaChecked] = useState(false);

  useEffect(() => {
    getLupa().then(lupa => {
      setIsKokeilulupaChecked(lupa.kokeilulupa);
    });
  }, [isKokeilulupaChecked]);

  return (
    <Lomake
      anchor={"kokeilulupa"}
      changeObjects={changeObjects}
      data={isKokeilulupaChecked}
      mode="addition"
      isInExpandableRow={false}
      isReadOnly={false}
      path={["esittelija", "kokeilulupa"]}
    />
  );
};

const getLupa = async () => {
  return await localForage.getItem(PaikallisenTietovarastonAvain.LUPA);
};

export default Kokeilulupa;
